import { escapeHtml } from './attributeParsing.js';
import { pdfLabelFor, renderLabeledValuePdfHtml } from './pdf.js';
/**
 * Allowed upload extensions for the attachment channel. The server extension
 * gate and the client file-input accept list both derive from these so they
 * can never disagree. HEIC/HEIF is accepted upstream and transcoded to jpg
 * before the extension gate runs (existing selfie-upload behavior).
 */
export const ATTACHMENT_ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'pdf'];
export const ATTACHMENT_ACCEPT = 'application/pdf,image/*';
export const isFormUploadRecord = (value) => {
    if (!value || typeof value !== 'object')
        return false;
    const record = value;
    return typeof record.url === 'string' && record.url.length > 0;
};
export const attachmentUploadDescriptor = {
    type: 'attachment-upload',
    surfaces: ['rental-agreement'],
    blockLabel: 'Attachment Upload',
    defaultLabel: 'Upload your file',
    requiredDefault: true,
    extraAttrs: [],
    valueChannel: 'upload',
    editorPlaceholderHtml: (label) => `<div style="display:flex;align-items:center;gap:10px;pointer-events:none;">
      <span style="font-size:20px;">&#128206;</span>
      <div>
        <div style="font-weight:600;font-size:14px;color:#334155;">${escapeHtml(label)}</div>
        <div style="font-size:12px;color:#94a3b8;">Guest uploads a PDF or image file</div>
      </div>
    </div>`,
    validate: () => null,
    isComplete: (field, value) => !field.required || isFormUploadRecord(value),
    renderPdfHtml: (field, value) => {
        const label = pdfLabelFor(field);
        if (!isFormUploadRecord(value)) {
            return renderLabeledValuePdfHtml(label, '<span style="color:#94a3b8;">No file uploaded</span>');
        }
        if (value.mimeType && value.mimeType.startsWith('image/')) {
            return `<div style="margin:12px 0;">
        <div style="font-weight:600;font-size:14px;margin-bottom:6px;color:#1e293b;">${escapeHtml(label)}</div>
        <img src="${escapeHtml(value.url)}" style="max-width:100%;max-height:400px;border-radius:6px;" />
      </div>`;
        }
        return renderLabeledValuePdfHtml(label, `<span>&#128206; ${escapeHtml(value.fileName || 'Attachment')}</span><br/>
       <a href="${escapeHtml(value.url)}" style="font-size:12px;color:#2563eb;word-break:break-all;">${escapeHtml(value.url)}</a>`);
    },
};
